export const COMPARISON_1004_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_criteria_name: "",
    meta_criteria_image: "",
    meta_criteria_background_color: "#FFFFFF",
    meta_criteria_border_color: "#E6E6E6",
    meta_column1_text: "",
    meta_column1_image: "",
    meta_column2_text: "",
    meta_column2_image: "",
    meta_priority: 1,
    meta_status: 1,
  },

  METADATA_TITLES: {
    metadata: "Comparison Rows",
  },

  COMPARISON_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "pre_title",
      label: "Title Line 1 (Highlighted)",
      value: "CU Online",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter first title line (e.g., CU Online)",
      required: false,
      defaultValue: "CU Online",
    },
    {
      fieldName: "pre_title_color",
      label: "Title Line 1 Color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E1473F",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "title",
      label: "Title Line 2",
      value: "Traditional Learning",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter second title line (e.g., Traditional Learning)",
      required: false,
      defaultValue: "Traditional Learning",
      description:
        'A hardcoded "V/S" separator renders between the two title lines when this is set.',
    },
    {
      fieldName: "title_start_color",
      label: "Title Line 2 Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description (optional)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_text_color",
      label: "Description Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "column1",
      label: "Column 1 Header",
      value: "CU Online",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Column 1 header",
      required: false,
      defaultValue: "CU Online",
    },
    {
      fieldName: "column1_text_color",
      label: "Column 1 Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "column1_background_color",
      label: "Column 1 Background Color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E1473F",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "column2",
      label: "Column 2 Header",
      value: "Traditional Learning",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Column 2 header",
      required: false,
      defaultValue: "Traditional Learning",
    },
    {
      fieldName: "column2_text_color",
      label: "Column 2 Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "column2_background_color",
      label: "Column 2 Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Comparison Section Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Comparison Section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Criteria Name",
      fieldName: "meta_criteria_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Mode of Learning",
      required: false,
    },
    {
      header: "Criteria Icon",
      fieldName: "meta_criteria_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
      required: false,
      defaultValue: "",
    },
    {
      header: "Criteria BG Color",
      fieldName: "meta_criteria_background_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Criteria Border Color",
      fieldName: "meta_criteria_border_color",
      value: "#E6E6E6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E6E6E6",
      required: false,
      defaultValue: "#E6E6E6",
    },
    {
      header: "Column 1 Value",
      fieldName: "meta_column1_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Column 1 content (desktop only)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Column 1 Icon",
      fieldName: "meta_column1_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
      required: false,
      defaultValue: "",
    },
    {
      header: "Column 2 Value",
      fieldName: "meta_column2_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Column 2 content (desktop only)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Column 2 Icon",
      fieldName: "meta_column2_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1 = active",
      required: false,
      defaultValue: 1,
    },
  ],
};
